import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalizedSchemaService } from '../../../services/localized-schema.service';

@Component({
  selector: 'app-typo3-webseiten',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './typo3-webseiten.component.html',
  styleUrl: './typo3-webseiten.component.scss'
})
export class Typo3WebseitenComponent implements OnInit, OnDestroy {
  private readonly schemaId = 'typo3-service-schema';

  constructor(@Inject(DOCUMENT) private document: Document, private schema: LocalizedSchemaService) { }

  ngOnInit(): void {
    if (this.document.getElementById(this.schemaId)) {
      return;
    }

    const script = this.document.createElement('script');
    script.id = this.schemaId;
    script.type = 'application/ld+json';
    script.text = this.schema.serialize({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Service',
          name: $localize`TYPO3-Webseiten und Webseitenpflege`,
          serviceType: $localize`TYPO3-Entwicklung, Wartung und Webseitenpflege`,
          description: $localize`AlbCode entwickelt, modernisiert und pflegt TYPO3-Webseiten für Unternehmen.`,
          url: 'https://www.albcode.de/albcode/typo3-webseiten',
          areaServed: {
            '@type': 'Country',
            name: $localize`Deutschland`
          },
          provider: {
            '@type': 'Organization',
            name: $localize`AlbCode`,
            url: 'https://www.albcode.de/'
          }
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: $localize`Startseite`,
              item: 'https://www.albcode.de/'
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: $localize`TYPO3-Webseiten und Webseitenpflege`,
              item: 'https://www.albcode.de/albcode/typo3-webseiten'
            }
          ]
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: $localize`Kann AlbCode eine bestehende TYPO3-Webseite übernehmen?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Ja. Wir prüfen Installation, Erweiterungen, Templates und technischen Zustand und schlagen anschließend die passenden nächsten Schritte vor.`
              }
            },
            {
              '@type': 'Question',
              name: $localize`Übernimmt AlbCode auch die laufende TYPO3-Pflege?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Ja. Wir unterstützen bei TYPO3-Updates, Sicherheitsaktualisierungen, Fehlerbehebung, Erweiterungen und der technischen Weiterentwicklung.`
              }
            },
            {
              '@type': 'Question',
              name: $localize`Können Inhalte weiterhin selbst gepflegt werden?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Ja. Wir richten verständliche Inhaltsbausteine ein und unterstützen Ihr Team auf Wunsch bei der Einarbeitung in die redaktionelle Pflege.`
              }
            }
          ]
        }
      ]
    });

    this.document.head.appendChild(script);
  }

  ngOnDestroy(): void {
    this.document.getElementById(this.schemaId)?.remove();
  }
}
